import React from 'react'
import './index.css'

class VideoModal extends React.Component {
	render () {
		return (this.props.visible ?
			<div className='videoModal'>
				<div className='modalMask'></div>
				<div className='modalWarp'>
					<div className='modal'>
						<div className='img'></div>
						<div className='title'>直播太火爆啦!</div>
						<div className='body'>亲爱的用户，因直播业务访问量巨大，本直播间观看人数已达到上限，建议您通过河南有线机顶盒业务进行收看，敬请谅解!</div>
						<div className='button' onClick={this.props.onClose}>确定</div>
					</div>
				</div>
			</div>
			: null
		)
	}
}

export default VideoModal